const cf = (process.env.NODE_ENV === "dev") ? require("./local.config") : require("./prod.config");


export default cf.default;
